<template>
    <el-row class="nav-menu">
        <el-col style="height: 60px;">
        <el-menu
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            text-color="#fff"
            :default-active="activeIndex"
            background-color="#2b3849"
            active-text-color="#fff"
            >
                <!--<el-submenu 
                    v-for="(item,index) in navMenu"
                    v-if="item.LowerLevel"
                    :index="index+''">
                    <template slot="title">{{item.Name}}</template>
                    <el-menu-item
                        v-for="(Ite,Ind) in item.LowerLevel"
                        :index="index+''+'-'+Ind+''">
                            <router-link class="aLink" :to="Ite.url == '/'?'/404':Ite.url">
                                {{Ite.Name}}
                            </router-link>
                        </el-menu-item>
                </el-submenu>-->
                <el-menu-item v-for="(item,index) in navMenu" :index="index+''">
                    <router-link :to="item.url">{{item.name}}</router-link>
                </el-menu-item>
            
        </el-menu>
        </el-col>
    </el-row>
</template>

<script>
    
    export default {
        data() {
            return {
                role_name: localStorage.getItem('role_name'),
                activeIndex: '0',
                navMenu: [],
            };
        },
        mounted() {
            this.initNavHandle();
        },
        
        watch:{
            $route(to,from){
                var index = this.navMenu.findIndex(item => item.url == to.path);
                this.activeIndex = index.toString();
                if(index == -1) {
                    this.$router.push({path:'/403'});
                    return false
                }
            }
        },
        
        methods: {
            initNavHandle() {   
                const this_ = this
                const url = this_.$route.path;
                this_.$api.get(this_.GLOBAL.IP + '/naviGat/getMenu')
                .then(res => {
                    this_.navMenu = res.data;
                    var index = this.navMenu.findIndex(item => item.url == url);
                    this.activeIndex = index.toString();
                    if(index == -1) {
                        this_.$router.push({path:'/403'})
                        return false
                    }
                }).
                catch(err => {
                    this.$message.error('导航栏获取失败');
                    this.navMenu = [];
                })
            },
            handleSelect(key, keyPath) {
                
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/assets/css/vars.scss';
    .el-menu {
        background: $main-Defaultcolor;
        height: 100%;
    }
    .nav-menu a {
        display: inline-block;
    }
    .nav-menu >>> .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
        color: #fff !important;
    }
    .el-menu--horizontal>.el-menu-item {
        border-bottom: none !important;
    }
    .nav-menu >>> .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
        border-bottom: none !important;
    }
    .nav-menu .el-menu--horizontal>.el-menu-item.is-active {
        background: $main-DefaultActivecolor !important;
        
    }
    .el-menu--horizontal .el-menu .el-menu-item a {
        color:#fff;
    }
    .aLink {
        display: inline-block;
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/views/home/components/NavMenu.vue